export const projectContactsByProjectId = (state, getters) => project_id => {
    project_id = parseInt(project_id)

    return _.reduce(_.filter(state.projectContacts.items, {project_id}), (res, item) => {
        let contact = getters.contactById(item.contact_id)
        contact = _.clone(contact)
        contact.pivot = {role: item.role}
        if (contact) res.push(contact)
        return res
    }, [])
}

export const contactProjectsByContactId = (state, getters) => contact_id => {
    return _.filter(getters.projects, {contact_id})
}
